import styles from './List.module.scss'
import ListItem from "../ListItem/ListItem";
import {template} from "../ListWithRedactor/ListWithRedactor";
import {RefObject} from "react";
export type ListProps = {
    list:template[]
    selectedId:number
    setId:(value:number)=>void
    setName:(value:string)=>void
    setPattern:(value:string)=>void
    setJsonExample:(value:string)=>void
    deleteByName:(value:string)=>void
    showDemo:(value:string)=>void
}
export default function List(props:ListProps){
    return(
        <div className={styles.List}>
            {props.list.map((item)=><ListItem
                key={item.id}
                id={item.id}
                renderedTemplate={item.renderedTemplate}
                name={item.name}
                pattern={item.pattern}
                jsonExample={JSON.stringify(item.jsonExample)}
                selectedId={props.selectedId}
                setSelectedId={props.setId}
                setId={props.setId}
                setName={props.setName}
                setPattern={props.setPattern}
                setJsonExample={props.setJsonExample}
                deleteByName={props.deleteByName}
                showDemo={props.showDemo}
            />)}
        </div>
    )
}